import React from "react";

const EduAndExp = () =>
{
    return (
      <>
        <div className="salv-about-edu-expr">
          <div className="row sal-about-eduction-row">
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 salv-eduction-col">
              <h6 className="salv-about-personla-title mb-0 w-text dark-about-personal-title sm-md-font inter-font-700 mb-0">
                background
              </h6>
              <div className="about-educ-card-wrap">
                <div className="eduction-card edu-card-one dark-edu-card">
                  <div className="year-edu-className">
                    <div className="educ-year">2020 to Present</div>
                    <p className="about-edu-title sm-md-font w-text inter-font-500 mb-0">
                      Professional Development
                    </p>
                  </div>
                  <div className="about-desc sm-font-two inter-font-400 dark-sec-color">
                    I keep learning through real client work across web
                    development, APIs, WordPress, VPS hosting, and business
                    systems like LMS, HRMS, and CRM.
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 salv-experience-col">
              <h6 className="salv-about-personla-title mb-0 w-text dark-about-personal-title sm-md-font inter-font-700 mb-0">
                experience
              </h6>
              <div className="about-educ-card-wrap">
                <div className="eduction-card edu-card-one dark-edu-card">
                  <div className="year-edu-className">
                    <div className="educ-year">June 2025 to Present</div>
                    <p className="about-edu-title sm-md-font w-text inter-font-500 mb-0">
                      Software Engineer, I Media5
                    </p>
                  </div>
                  <div className="about-desc sm-font-two inter-font-400 dark-sec-color">
                    I build modern web apps with the MERN stack, work on
                    progressive web apps for UK schools, manage VPS servers with
                    Nginx, and keep production apps reliable.
                  </div>
                </div>
                <div className="eduction-card edu-card-two dark-edu-card">
                  <div className="year-edu-className">
                    <div className="educ-year">April to October 2025</div>
                    <p className="about-edu-title sm-md-font w-text inter-font-500 mb-0">
                      WordPress Developer, Gafari Marketing
                    </p>
                  </div>
                  <div className="about-desc sm-font-two inter-font-400 dark-sec-color">
                    I built and customized WordPress websites, created responsive
                    layouts with Elementor and PageLayer, and turned design
                    requirements into working pages.
                  </div>
                </div>
                <div className="eduction-card edu-card-three dark-edu-card">
                  <div className="year-edu-className">
                    <div className="educ-year">August 2023 to 2025</div>
                    <p className="about-edu-title sm-md-font w-text inter-font-500 mb-0">
                      Full Stack Developer, Workzen
                    </p>
                  </div>
                  <div className="about-desc sm-font-two inter-font-400 dark-sec-color">
                    I developed full stack apps, integrated third party APIs,
                    built LMS and HRMS systems, worked on chat platforms and CRM
                    with GoHighLevel, and created custom business solutions.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
};
export default EduAndExp;
